import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { forgotPassword } from "../actions/accountActions";
import FormField from "../components/FormField";
import Alert from "../components/Alert";
import { withRouter } from "react-router";
import { required } from 'redux-form-validators'
import { withTranslation } from 'react-i18next';
import { clearResetPasswordFlag} from '../actions/flagsResetActions'

class ForgotPasswordForm extends Component {

    clearResetPasswordFlag() {
        this.props.clearResetPasswordFlag();
    };

    componentDidMount() {
        window.onbeforeunload = this.clearResetPasswordFlag.bind(this);
    }


    render() {
        const { t, handleSubmit, user } = this.props;
        const passwordAlreadyReset = user.isPasswordReset ? (
            <Alert type="success" title={t("Password Reset")} msg={t("Your temporary password was sent successfully. please check your email.")} />
        ) : "";
      //  user.isPasswordReset = false; // reset this flag to not show after page refresh

        return (
            <Fragment>
                {passwordAlreadyReset}
                <div className="row justify-content-center">

                    <div className="col-lg-8 col-md-10">
                        <h2>{t("Forgot password?")}</h2>
                        < p > {t("Change your password in three easy steps. This helps to keep your new password secure.")}</p>
                        <ol className="list-unstyled">
                            <li><span className="text-primary text-medium">1. </span>{t("Fill in your email address below.")}</li>
                            <li><span className="text-primary text-medium">2. </span>{t("We'll email you a temporary password.")}</li>
                            <li><span className="text-primary text-medium">3. </span>{t("Use the temporary password to change your password on our secure website.")}</li>
                        </ol>
                        <form
                            className="card mt-4"
                            method="post"
                            onSubmit={handleSubmit(this.props.forgotPassword)} >
                            <div className="card-body">
                                <div className="form-group">
                                    <label htmlFor="email-for-pass">{t("Enter your email/username")}</label>
                                    <Field
                                        className="form-control"
                                        type="text"
                                        name="username"
                                        icon="icon-head"
                                        component={FormField}
                                        placeholder={t("email/username")}
                                        validate={[required({msg: t("is required")})]}
                                    />
                                    <small className="form-text text-muted">{t("Type in your email address you used when you registered with ENJO. Then we'll email a temporary password to this address.")}</small>
                                </div>
                            </div>
                            <div className="card-footer">
                                <button className="btn btn-primary" type="submit">{t("Get New Password")}</button>
                            </div>
                        </form>
                    </div>
                </div>

            </Fragment>
        );
    }
}

function validate(values, props) {
    const errors = {};
    const { t } = props;
    if (!values.username) {
        errors.username = t("Enter a username");
    }

    if (!values.password) {
        errors.password = t("Enter a password");
    }
    return errors;
}

function mapStateToProps({ user }, ownProps) {
    return { user, initialValues: { username: user.email }, ...ownProps };
}

ForgotPasswordForm = connect(mapStateToProps, { forgotPassword, clearResetPasswordFlag })(ForgotPasswordForm);

ForgotPasswordForm = withRouter(reduxForm({
    form: "ForgotPasswordForm",
    validate
})(ForgotPasswordForm));

// The following duplicate line is a workaround to allow the binding the form initial values from stats as the order of connect and router has a conflict. if we bind to static data we don't need this line
// need more investigation to figure if it is from our side
ForgotPasswordForm = connect(mapStateToProps, { forgotPassword, clearResetPasswordFlag })(ForgotPasswordForm);

export default withTranslation()(ForgotPasswordForm);
